// extracted by mini-css-extract-plugin
module.exports = {"container":"_3FUjPwTOZD8k41G3tENZJj","icon":"_2ezo9Hn2Gyr9lppEXEgkl6"};